enum CareType {
  BABYSITTER = 'BABYSITTER',
  NANNY = 'NANNY',
  HOUSEKEEPING = 'HOUSEKEEPING',
  PET_CARE = 'PET_CARE',
  SPECIAL_NEEDS = 'SPECIAL_NEEDS',
  COMPANION_CARE = 'COMPANION_CARE',
}

export { CareType };

export function parseCareType(value?: string | null): CareType | null {
  return Object.values(CareType).find((type) => type === value?.toUpperCase()) ?? null;
}
